import { useEffect, useRef, useState } from "react";
import { useUserContext } from "../../context/UserContext";
import OnlineMenuService, { StatisticIdentifiers } from "../../api/service/OnlineMenuService";
import { FoodsObj } from "../../api/model/response/OnlineMenuResponseModel";

const OnlineMenuStartupHook = () => {
  const { currentOnlineMenu, currentCompanyInfo, currentLanguagesList } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [foundedFoodList, setFoundedFoodList] = useState<FoodsObj[]>([]);
  const searchBoxRef = useRef<any>();
  const [searchIsFocused, setSearchIsFocused] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(
    currentCompanyInfo?.announcementObj?.some((value) => value.photoUrl) ?? false
  );

  useEffect(() => {
    setShowAnnouncement(currentCompanyInfo?.announcementObj?.some((value) => value.photoUrl) ?? false);
  }, [currentCompanyInfo]);

  useEffect(() => {
    const handleResize = () => {
      if (searchIsFocused && searchBoxRef.current) {
        searchBoxRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [searchIsFocused]);

  useEffect(() => {
    if (!currentOnlineMenu.title) setIsLoading(true);
    else {
      setIsLoading(false);
    }
  }, [currentOnlineMenu]);

  useEffect(() => {
    const found: FoodsObj[] = [];
    currentOnlineMenu?.categoriesObj?.forEach((category) => {
      category?.foodsObj?.forEach((food) => {
        if (food?.title?.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())) {
          found.push(food);
        } else {
          food?.subFoodsObj?.forEach((value) => {
            if (value?.title?.includes(searchValue)) {
              found.push(food);
            }
          });
        }
      });
    });
    setFoundedFoodList(found);
  }, [searchValue]);

  return {
    currentOnlineMenu,
    currentCompanyInfo,
    isLoading,
    searchValue,
    setSearchValue,
    foundedFoodList,
    currentLanguagesList,
    searchIsFocused,
    setSearchIsFocused,
    searchBoxRef,
    showAnnouncement,
    setShowAnnouncement
  };
};
export default OnlineMenuStartupHook;
